var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentTime)?_c('div',{staticClass:"point-time",on:{"click":_vm.changeTime}},[_c('img',{attrs:{"src":require("@/assets/img/bficon.png")}}),_c('span',[_vm._v(_vm._s(_vm.getTime(_vm.currentTime)))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }